import MyVideo from "../../../../src/components/MyVideo";
import * as React from 'react';
export default {
  MyVideo,
  React
};